export default __webpack_public_path__ + "static/media/006-eagle.1c37e333.svg";